import React from 'react'
import { Authorized } from '../../../src/common/modules/auth/Authorized'
import { SCOPES } from '../../../src/config/constants'
import { FetchEmployee } from '../../../src/end-user/FetchEmployee'
import { PageStatistics } from '../../../src/common/modules/statistics/PageStatistics'

export default () => (
  <Authorized scope={SCOPES.Holder}>
    <FetchEmployee>
      <PageStatistics />
    </FetchEmployee>
  </Authorized>
)
